export const EMPTY_VALUE = '-'
